import React from 'react';
import style from './AppCTA.module.scss';
import lighthouseImg from '../imgs/LIghthouse.jpg';
import storeListings from '../constants/store.constants';

const AppCTA = () => (
    <section className={style.aboutSection} id="about">
        <div className="wrap">
            <div className={style.appCta}>
                <div>
                    <div className="eyebrow" style={{ color: 'var(--ink-deep)' }}>Take it with you</div>
                    <h2>Carry local history in your pocket.</h2>
                    <p>Get the app before your next walk, trip, or commute — and let the places around you start talking back.</p>
                    <div className={style.appButtons}>
                        <a href={storeListings.appStore} target="_blank" rel="noopener noreferrer" className={style.appBtn}>Download on the App Store</a>
                        <a href={storeListings.googlePlayStore} target="_blank" rel="noopener noreferrer" className={style.appBtn}>Get it on Google Play</a>
                    </div>
                </div>
                <div className={style.appVisual}>
                    <img src={lighthouseImg} alt="Yesterday Stories app in use at a lighthouse" />
                </div>
            </div>
        </div>
    </section>
);

export default AppCTA;
